import { CustomReportConfig } from "./reportConfigModel"
import dayjs from 'dayjs'
import { convertSortValues, CountType } from '@/component/ReportCommon/share/params';
import { DateDisabledHandler } from "@/utils/utils";
import { FilterAll, FilterSelectProps, FilterTypes } from "@/component/FilterCommon/Filter";

export interface ReportConfig {
  accounts_id: string //  "1"
  company_id: number,
  first_collaborator_company_id?: number  //联营端报表才有
  config:{
    report_config: CustomReportConfig,
    report_id: string //  "1"
    report_name:string //  "客户订货行为"
    slug:string //  "clientOrder"
    help_info:string //
  }
}

export type ServiceQuickBiReportDataParams = ReportParams & {
  source:string,
  report:string,
  template_code?:string,
  count?:CountType 
  transformer_fields?: string
  collaborator_company_id?: number //运营公司id
}


export const SortOrder:{
  descend: 'descend',
  ascend: "ascend" ,
} = {
  descend: 'descend',
  ascend: "ascend" ,
}
export type SortOrderParams = 'descend' | 'ascend' | null|undefined
export type SortParams = {dataIndex:string, order: SortOrderParams}[]

export type ReportParams = {
  sortParams?: SortParams
  [x:string]: string| SortParams | undefined|number,
}


const getSerchObject = () => {
  const search = window.location.search;
  if (search) {
    const paramsValue = new URLSearchParams(search);
    const searchObj = Object.fromEntries(paramsValue.entries());
    return searchObj;
  }
  return {};
}

export const getSearchParams = () => {
  let searchArray = [] as any;
  const searchObj = getSerchObject();
  if (searchObj && searchObj.params) {
    searchArray = JSON.parse(searchObj.params);
  }
  return searchArray;
}

// 获取url上携带的时间戳
export const getSearchTimestamp = () => {
  let timeStamp = undefined;
  const searchObj = getSerchObject();
  if (searchObj && searchObj.timeStamp) {
    timeStamp = searchObj.timeStamp;
  }
  return timeStamp;
}


export const getDefaultParams = (configData:ReportConfig)=>{
  const isAffilliate = configData.first_collaborator_company_id && Number(configData.first_collaborator_company_id) > 0
  const config =  configData.config.report_config
  if(!isAffilliate){
    configData.first_collaborator_company_id = undefined
  }
  let defaultParams = {} as ServiceQuickBiReportDataParams
  if(isAffilliate){
    defaultParams.collaborator_company_id = configData.first_collaborator_company_id
  }
  if(!config){
    return {
      defaultParams,
      report_config: config
    }
  }
  let format = 'YYYY-MM-DD HH:mm:ss'
  config.modules.forEach(moduleItem=>{
    if(moduleItem.type == 'filter'){
      let filterList  = moduleItem.list.map(item=>{
        if(item.type == 'DatePick'){
          let dayValue: dayjs.Dayjs | null = null;
          if (item.endYear) {
            const endDateLimit = DateDisabledHandler.calculateEndDateLimit(item.endYear);
            dayValue = endDateLimit instanceof Date ? dayjs(endDateLimit) : endDateLimit;
          } else if (item.startYear) {
            const startDateLimit = DateDisabledHandler.calculateEndDateLimit(item.startYear);
            if (startDateLimit instanceof Date) {
              dayValue = dayjs(startDateLimit).subtract(30, 'days');
            } else if (startDateLimit) {
              dayValue = startDateLimit.subtract(30, 'days');
            }
          }

          if (dayValue) {
            if (item.startDay) {
              dayValue = dayValue.startOf('day');
            }
            if (item.endDay) {
              dayValue = dayValue.endOf('day');
            }
            item.value = dayValue.format('YYYY-MM-DD HH:mm:ss');
          }
          
          if(item.addDay !== undefined && !item.value){
            let defaultPicker:any = 'day'
            let dayValue = dayjs().add(Number(item.addDay), defaultPicker) as dayjs.Dayjs
            let picker = item.picker || defaultPicker
            if(item.startDay){
              dayValue =dayValue.startOf(picker)
            }
            if(item.endDay){
              dayValue = dayValue.endOf(picker)
            }
            item.value = dayValue.format('YYYY-MM-DD HH:mm:ss')
          }
          delete item.endYear
          delete item.startYear
          delete item.addDay
        }
        if(item.type == "DateUnitPick"){
          let {dataIndex,dataIndexTwo} = item
          let date = dayjs(item.value)
          let picker = item.picker || 'day' as any
          let dateString = date.startOf(picker).format(format)
          defaultParams[dataIndex] = dateString
          item.value = dateString
          defaultParams[dataIndexTwo] = date.endOf(picker).format(format)
        }
        return item
      })
      filterList.forEach(item=>{
        if(item.value || item.value !== undefined){
          defaultParams[item.dataIndex] = item.value
        }
        delete item.value
      })
    }
    if(moduleItem.type == 'table'){
      let defaultSortFields = moduleItem.defaultSortFields.map(item=>{
        return {
          dataIndex: item.sortFieldId,
          order: convertSortValues(item.sortMethod)
        } 
      }) as ReportParams['sortParams']
      defaultParams.sortParams = defaultSortFields || []
      // defaultParams = convertSortParams(defaultParams,defaultSortFields)
    }
  })
  return {
    report_config:config,
    defaultParams,
    configData,
  }
}

const DHB_PARAMS_ENCRYPTED_PREFIX = '@dhb-params-encrypted:'
const FILTER_MODULE_TYPE = 'filter' as const
const URL_PARAM_VALUE_TYPE = {
  NUMBER: 'number',
} as const

type SearchParamValue = string | number | Array<string | number>

// 把字符串转成标准 Base64，供后端识别加密筛选值
const encodeUtf8ToBase64 = (params: { value: string }) => {
  const bytes = new TextEncoder().encode(params.value)
  const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('')
  return btoa(binary)
}

// 给筛选值加上 @dhb-params-encrypted: 前缀；已经带前缀的原样返回，避免重复编码
const encodeDhbParamsValue = (params: { value: string }) => {
  const { value } = params
  const hasEncryptedPrefix = value.startsWith(DHB_PARAMS_ENCRYPTED_PREFIX)
  if (hasEncryptedPrefix) {
    return value
  }
  const base64 = encodeUtf8ToBase64({ value })
  return `${DHB_PARAMS_ENCRYPTED_PREFIX}${base64}`
}

// 加密单个 Select 的默认值和选项值，label 保持原文，保证下拉选中值和请求参数一致
const encryptSelectItem = (params: { item: FilterSelectProps }) => {
  const { item } = params
  if (typeof item.value === 'string') {
    item.value = encodeDhbParamsValue({ value: item.value })
  }
  const options = item.options || []
  options.forEach(option => {
    if (typeof option.value !== 'string') {
      return
    }
    option.value = encodeDhbParamsValue({ value: option.value })
  })
}

// 加密 URL 带入的筛选值，字符串直接加密，数组则逐项加密
const encryptSearchParamValue = (params: { value: SearchParamValue }): SearchParamValue => {
  const { value } = params
  if (typeof value === 'string') {
    return encodeDhbParamsValue({ value })
  }
  if (!Array.isArray(value)) {
    return value
  }
  return value.map(item => {
    if (typeof item !== 'string') {
      return item
    }
    return encodeDhbParamsValue({ value: item })
  })
}

// 预处理报表配置：filter 里 type 为 Select 的项，在取默认参数前把 value 和 options.value 加密
export const encryptReportFilterSelectParams = (params: { configData?: ReportConfig }) => {
  const modules = params.configData?.config?.report_config?.modules
  if (!modules) {
    return
  }
  modules.forEach(moduleItem => {
    if (moduleItem.type != FILTER_MODULE_TYPE) {
      return
    }
    moduleItem.list.forEach(item => {
      if (item.type != FilterTypes.Select) {
        return
      }
      encryptSelectItem({ item })
    })
  })
}

// 接口发出前加密筛选参数。filter 里 type 为 Select 的字段会转成加密串；session 缓存和父页面回传的明文不会改存储
export const encryptReportRequestParams = <T extends Record<string, any>>(params: {
  configData?: ReportConfig
  requestParams: T
}): T => {
  const modules = params.configData?.config?.report_config?.modules
  if (!modules) {
    return params.requestParams
  }
  const requestParams: Record<string, any> = { ...params.requestParams }
  modules.forEach(moduleItem => {
    if (moduleItem.type != FILTER_MODULE_TYPE) {
      return
    }
    moduleItem.list.forEach(item => {
      if (item.type != FilterTypes.Select) {
        return
      }
      const currentValue = requestParams[item.dataIndex]
      if (typeof currentValue !== 'string' && typeof currentValue !== 'number' && !Array.isArray(currentValue)) {
        return
      }
      requestParams[item.dataIndex] = encryptSearchParamValue({ value: currentValue })
    })
  })
  return requestParams as T
}

// 处理 URL 上的同名筛选参数。对应项是 Select，且值不是 number 时才加密
export const encryptUrlSelectValue = (params: {
  filterItem?: FilterAll
  value: SearchParamValue
  valueType?: 'string' | 'number'
}): SearchParamValue => {
  const { filterItem, value, valueType } = params
  if (!filterItem) {
    return value
  }
  if (filterItem.type != FilterTypes.Select) {
    return value
  }
  if (valueType == URL_PARAM_VALUE_TYPE.NUMBER) {
    return value
  }
  return encryptSearchParamValue({ value })
}
